import * as React from 'react';
import { WorkArea } from './useTimeTrackings';
import css from './TimeTrackings.module.css';

interface TTSelectionBarProps {
  bulkWAOpen: boolean;
  setBulkWAOpen: (open: boolean) => void;
  bulkBusy: boolean;
  bulkWorkAreaId: number | null;
  setBulkWorkAreaId: (id: number | null) => void;
  selectedTTIds: Set<number>;
  workAreas: WorkArea[];
  applyBulkChangeWorkArea: () => Promise<void>;
  toast: { type: 'success' | 'error' | 'info'; text: string } | null;
}

const TOAST_COLORS: Record<string, string> = {
  success: '#22c55e',
  error: '#ef4444',
  info: '#5271A5',
};

export function TTSelectionBar({
  bulkWAOpen,
  setBulkWAOpen,
  bulkBusy,
  bulkWorkAreaId,
  setBulkWorkAreaId,
  selectedTTIds,
  workAreas,
  applyBulkChangeWorkArea,
  toast,
}: TTSelectionBarProps): React.JSX.Element {
  return (
    <>
      {bulkWAOpen && (
        <div
          className={css.bulkOverlay}
          onClick={() => !bulkBusy && setBulkWAOpen(false)}
        >
          <div className={css.bulkCard} onClick={(e) => e.stopPropagation()}>
            <h3 className={css.bulkTitle}>Change Work Area ({selectedTTIds.size})</h3>
            <div className={css.bulkSelectWrap}>
              <select
                value={bulkWorkAreaId ?? ''}
                onChange={(e) => setBulkWorkAreaId(e.target.value ? Number(e.target.value) : null)}
                className={css.bulkSelect}
              >
                <option value="">(select work area)</option>
                {workAreas.map(wa => (
                  <option key={wa.id} value={wa.id}>{wa.name}</option>
                ))}
              </select>
            </div>
            <div className={css.bulkFooter}>
              <button className="btn" onClick={() => setBulkWAOpen(false)} disabled={bulkBusy}>Abbrechen</button>
              <button className="btn btn--primary" onClick={applyBulkChangeWorkArea} disabled={!bulkWorkAreaId || bulkBusy}>Übernehmen</button>
            </div>
          </div>
        </div>
      )}
      {toast && (
        <div
          className={css.toast}
          style={{ background: TOAST_COLORS[toast.type] || TOAST_COLORS.info }}
        >
          {toast.text}
        </div>
      )}
    </>
  );
}
